import { Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { OsXFinancialFilterOsBy } from '@/core/domain/questReport/Reports/OsXFinancial/OsXFinancial.types';

const FinancialForm = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Row>
      <Col sm={24}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'movimentOsXFinancial.form.overview.filterBudgetBy',
          })}
        </Title>

        <Form.Item
          name="filterOsBy"
          initialValue={OsXFinancialFilterOsBy.emission}
          noStyle
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={OsXFinancialFilterOsBy.emission}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.issue',
              })}
            </Radio>
            <Radio value={OsXFinancialFilterOsBy.dueDate}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.dueDate',
              })}
            </Radio>
            <Radio value={OsXFinancialFilterOsBy.receipt}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.overview.filterBudgetBy.receipt',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};
export default FinancialForm;
